export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "当前入口", href: "#current" },
  { label: "最新动态", href: "#timeline" },
  { label: "域名迁移", href: "#migrate" },
  { label: "历史版本", href: "#archive" },
  { label: "换新指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export interface EntryCard {
  tag: string;
  name: string;
  domain: string;
  status: "online" | "standby" | "offline";
  statusText: string;
  region: string;
  speed: string;
  note: string;
}

export const currentEntries: EntryCard[] = [
  {
    tag: "官方主站",
    name: "吃瓜地址 · 正式版",
    domain: "cgdz-vip.top",
    status: "online",
    statusText: "当前在线",
    region: "全球节点",
    speed: "延迟 42ms",
    note: "换新地址后稳定运行，建议优先使用并收藏本站，防止再次迁移后走失。",
  },
  {
    tag: "备用通道 A",
    name: "吃瓜地址 · 备用线",
    domain: "cgdz-a.net",
    status: "standby",
    statusText: "备用可用",
    region: "亚太节点",
    speed: "延迟 58ms",
    note: "主站拥堵时切换到此备用入口，内容与正式版保持同步更新。",
  },
  {
    tag: "镜像归档",
    name: "历史版本镜像",
    domain: "arc.cgdz.info",
    status: "offline",
    statusText: "归档维护",
    region: "静态镜像",
    speed: "只读访问",
    note: "历史版本与往期入口快照，仅作回溯存档，暂停对外发布服务。",
  },
];

export interface Notice {
  date: string;
  title: string;
  summary: string;
}

export const tickerNotices: string[] = [
  "公告：吃瓜地址已完成 2026 年第六轮换新地址，旧域名将在一周内停用。",
  "提醒：请第一时间把本页加入收藏夹，域名迁移后即可经此找到最新入口。",
  "动态：历史版本 V7.2 已归档，往期入口访问入口见下方时间线。",
  "提示：绑定邮箱或微信提醒，换新地址后系统会第一时间推送新域名。",
  "公告：备用通道 A 今日扩容完成，高峰期访问更顺畅。",
];

export interface TimelineItem {
  id: string;
  date: string;
  version: string;
  title: string;
  summary: string;
  state: "latest" | "online" | "archived" | "offline";
  url?: string;
}

export const historyTimeline: TimelineItem[] = [
  {
    id: "t1",
    date: "2026-08-30",
    version: "V9.0",
    title: "换新地址 · 正式版迁移上线",
    summary: "完成第六轮域名迁移，正式版换新地址并开启全节点加速。",
    state: "latest",
    url: "cgdz-vip.top",
  },
  {
    id: "t2",
    date: "2026-06-18",
    version: "V8.5",
    title: "备用通道 A 扩容升级",
    summary: "备用入口升级为双节点，原网址仍可访问并跳转新地址。",
    state: "online",
    url: "cgdz-a.net",
  },
  {
    id: "t3",
    date: "2026-04-02",
    version: "V7.2",
    title: "历史版本镜像归档开放",
    summary: "往期入口与历史版本以只读镜像形式对外回溯。",
    state: "archived",
  },
  {
    id: "t4",
    date: "2026-01-20",
    version: "V6.1",
    title: "第五轮域名迁移",
    summary: "旧网址被多次屏蔽，紧急切换至新域名并同步发布历史。",
    state: "offline",
  },
  {
    id: "t5",
    date: "2025-09-15",
    version: "V5.0",
    title: "第四轮换新地址",
    summary: "正式启用 HTTPS 全站加密，旧域名停止解析。",
    state: "offline",
  },
  {
    id: "t6",
    date: "2025-05-01",
    version: "V3.6",
    title: "早期历史版本收录",
    summary: "整理第一至第三轮旧网址与发布历史，形成完整档案。",
    state: "offline",
  },
];

export interface MigrationRow {
  no: number;
  from: string;
  to: string;
  date: string;
  reason: string;
  impact: string;
}

export const migrationRows: MigrationRow[] = [
  {
    no: 6,
    from: "cgdz.top",
    to: "cgdz-vip.top",
    date: "2026-08-30",
    reason: "主动换新地址、升级节点",
    impact: "无感知",
  },
  {
    no: 5,
    from: "vip.cgdz.net",
    to: "cgdz.top",
    date: "2026-01-20",
    reason: "旧网址被屏蔽",
    impact: "约 2 小时",
  },
  {
    no: 4,
    from: "cgdz.xyz",
    to: "vip.cgdz.net",
    date: "2025-09-15",
    reason: "原域名到期未续",
    impact: "约 6 小时",
  },
  {
    no: 3,
    from: "new.cgdz.cc",
    to: "cgdz.xyz",
    date: "2025-05-01",
    reason: "业务整合迁移",
    impact: "无感知",
  },
];

export interface OldEntry {
  domain: string;
  range: string;
  statusText: string;
  status: "offline" | "redirect" | "archived";
  note: string;
}

export const oldEntries: OldEntry[] = [
  {
    domain: "cgdz.xyz",
    range: "2025-05 ~ 2026-01",
    statusText: "已停用",
    status: "offline",
    note: "第三轮换新地址时期主站，域名到期后停止解析。",
  },
  {
    domain: "vip.cgdz.net",
    range: "2025-09 ~ 2026-08",
    statusText: "已下线",
    status: "offline",
    note: "第四轮发布后启用，后续因旧网址被屏蔽而下线。",
  },
  {
    domain: "cgdz.top",
    range: "2026-01 ~ 2026-08",
    statusText: "已跳转",
    status: "redirect",
    note: "第五轮换新地址主域名，现自动跳转到当前最新地址。",
  },
  {
    domain: "new.cgdz.cc",
    range: "2024-11 ~ 2025-05",
    statusText: "已归档",
    status: "archived",
    note: "早期往期入口，已进入历史版本镜像供回溯。",
  },
];

export interface GuideStep {
  no: string;
  title: string;
  desc: string;
  icon: string;
}

export const guideSteps: GuideStep[] = [
  {
    no: "01",
    title: "收藏本页",
    desc: "立刻把本页加入浏览器收藏，域名迁移后第一入口永远可回溯。",
    icon: "ri-star-line",
  },
  {
    no: "02",
    title: "绑定提醒",
    desc: "留下联系方式订阅换新地址推送，新域名上线第一时间告知。",
    icon: "ri-notification-3-line",
  },
  {
    no: "03",
    title: "认准徽章",
    desc: "认准官方主站与备用通道标识，谨防第三方仿冒旧网址钓鱼。",
    icon: "ri-shield-check-line",
  },
  {
    no: "04",
    title: "关注动态",
    desc: "定期查看下方发布历史与迁移记录，掌握最新换新地址节奏。",
    icon: "ri-route-line",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "为什么吃瓜地址总是换新地址？",
    a: "由于历史旧网址在不同时期受到不同程度的屏蔽与干扰，为保证访问稳定，官方会不定期执行域名迁移。每次换新地址都会在本页第一时间公布，并同步更新发布历史。",
  },
  {
    q: "旧网址还能访问吗？历史版本如何查看？",
    a: "已停用与已下线的旧网址无法直接访问；已跳转的旧网址会自动跳到当前最新地址。需要回溯历史版本与往期入口的，可在下方「历史版本」模块进入只读归档镜像。",
  },
  {
    q: "换新地址后我该怎么第一时间找到最新域名？",
    a: "最稳妥的办法是收藏本页，并绑定新地址提醒。每次换新地址后，页面顶部公告条与「当前入口」卡片会立刻更新，不必四处转发询问。",
  },
  {
    q: "如何区分官方入口与仿冒旧网址？",
    a: "官方入口统一带有「当前在线」「备用可用」状态徽章，且仅通过本页公布。任何要求付费、或域名与官方发布记录不一致的入口均为仿冒，请勿使用。",
  },
  {
    q: "备用通道和镜像归档有什么区别？",
    a: "备用通道内容与正式版完全同步，用于主站拥堵时分流；镜像归档仅收录历史版本与往期入口快照，为只读服务，不具备实时发布能力。",
  },
];

export interface TrustItem {
  value: string;
  label: string;
}

export const trustItems: TrustItem[] = [
  { value: "12+", label: "历史版本累计" },
  { value: "6 轮", label: "域名迁移记录" },
  { value: "99.9%", label: "入口可用率" },
  { value: "24h", label: "换新同步时效" },
];

export interface SubscribePoint {
  icon: string;
  title: string;
  desc: string;
}